import theme from 'src/shared/theme';
import { Area, PlacementItem } from '../placementAreaDesigner';
import { PlacementAreaDesignerManager } from '../placementAreaDesignerManager';
import PlacementAreaDesignerPlugin from './placementAreaDesignerPlugin';

export class PlacementAreaDesignerAreaSizePlugin implements PlacementAreaDesignerPlugin {
    private manager!: PlacementAreaDesignerManager;

    private layer!: paper.Layer;
    private widthLabel!: paper.Group;
    private heightLabel!: paper.Group;
    private areaNameLabel!: paper.Group;

    public create = (manager: PlacementAreaDesignerManager) => {
        this.manager = manager;
        this.layer = new manager.paper.Layer();
        this.layer.bringToFront();

        this.widthLabel = new manager.paper.Group();
        this.widthLabel.applyMatrix = false;
        this.layer.addChild(this.widthLabel);

        this.heightLabel = new manager.paper.Group();
        this.heightLabel.applyMatrix = false;
        this.layer.addChild(this.heightLabel);

        this.areaNameLabel = new manager.paper.Group();
        this.areaNameLabel.applyMatrix = false;
        this.layer.addChild(this.areaNameLabel);

        this.createLabel(this.widthLabel);
        this.createLabel(this.heightLabel);
        this.createLabel(this.areaNameLabel);

        this.updateLabelsPosition();
    };

    private createLabel = (group: paper.Group) => {
        const rect = new this.manager.paper.Path.Rectangle(new this.manager.paper.Rectangle(0, 0, 80, 30), new this.manager.paper.Size(3, 3));
        // rect.fillColor = new this.manager.paper.Color('#ffffff');
        rect.strokeScaling = false;
        rect.strokeWidth = 0;
        rect.strokeColor = new this.manager.paper.Color(theme.app.primary);

        const text = new this.manager.paper.PointText(new this.manager.paper.Point(40, 20));
        text.content = '';
        text.fontSize = 12;
        text.fontWeight = 400;
        text.fontFamily = 'Montserrat, sans-serif';
        text.fillColor = new this.manager.paper.Color(theme.app.primary);
        text.justification = 'center';

        group.addChildren([rect, text]);
    };

    private updateLabelsText = (item: paper.Item) => {
        if (item) {
            (this.widthLabel.children[1] as paper.PointText).content =
                (item.bounds.width / this.manager.ppcm / this.manager.unit.ratio).toFixed(2) + ' ' + this.manager.unit.value;
            (this.heightLabel.children[1] as paper.PointText).content =
                (item.bounds.height / this.manager.ppcm / this.manager.unit.ratio).toFixed(2) + ' ' + this.manager.unit.value;
            (this.areaNameLabel.children[1] as paper.PointText).content = item.data.itemName ?? '';

            // Scale the label rectangle to fit the label size
            let scaleRatio = (this.widthLabel.children[1].bounds.width + 20) / this.widthLabel.children[0].bounds.width;
            this.widthLabel.children[0].scale(scaleRatio, 1);

            scaleRatio = (this.heightLabel.children[1].bounds.width + 20) / this.heightLabel.children[0].bounds.width;
            this.heightLabel.children[0].scale(scaleRatio, 1);

            scaleRatio = (this.areaNameLabel.children[1].bounds.width + 20) / this.areaNameLabel.children[0].bounds.width;
            this.areaNameLabel.children[0].scale(scaleRatio, 1);
        } else {
            throw new Error('Item cannot be null');
        }
    };

    public updateLabelsPosition = () => {
        if (this.manager.selectedPaperItem) {
            const scale = 1 / this.manager.paper.view.zoom;
            this.widthLabel.scaling = new this.manager.paper.Point(scale, scale);
            this.heightLabel.scaling = new this.manager.paper.Point(scale, scale);
            this.areaNameLabel.scaling = new this.manager.paper.Point(scale, scale);

            this.widthLabel.position = this.manager.selectedPaperItem.bounds.topCenter.add(new this.manager.paper.Point(0, -40 / this.manager.paper.view.zoom));
            this.heightLabel.position = this.manager.selectedPaperItem.bounds.leftCenter.add(
                new this.manager.paper.Point(-(40 + this.heightLabel.children[0].bounds.width / 2) / this.manager.paper.view.zoom, 0)
            );
            this.areaNameLabel.position = this.manager.selectedPaperItem.bounds.bottomCenter.add(
                new this.manager.paper.Point(0, 40 / this.manager.paper.view.zoom)
            );

            this.layer.visible = this.manager.selectedPaperItem.data.labelVisibility;
        } else if (this.layer.visible) {
            this.layer.visible = false;
        }
    };

    public onViewZoomChanged = () => {
        this.updateLabelsPosition();
    };

    public onAreaSelectionChanged = (item: paper.Item, area: Area | PlacementItem, selected: boolean) => {
        if (selected) {
            // Update text only for selected item, this event is triggered also for deselect
            this.updateLabelsText(item);
        }

        this.updateLabelsPosition();
    };

    public onUnitChange = () => {
        if (this.manager.selectedPaperItem) this.updateLabelsText(this.manager.selectedPaperItem);
    };

    public onAreaMoving = () => {
        this.updateLabelsPosition();
    };

    public onAreaRotateStart = () => {
        this.layer.visible = false;
    };

    public onAreaResizeStart = () => {
        this.layer.visible = false;
    };

    public onAreaResizeEnd = (item: paper.Item) => {
        this.updateLabelsPosition();
        this.updateLabelsText(item);
    };

    public onAreaRotateEnd = (item: paper.Item) => {
        this.updateLabelsPosition();
        this.updateLabelsText(item);
    };

    public onAreaRemoved = (item: paper.Item) => {
        this.updateLabelsPosition();
    };
}
